import { StyleSheet } from 'aphrodite';
import { charmGray } from '../../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	bulkActionsContainer: {
		marginBottom: '16px',
		padding: '16px',
		backgroundColor: 'rgba(255, 255, 255, 0.05)',
		border: `1px solid ${charmGray}`,
		borderRadius: '8px',
	},
	bulkActionsContent: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '12px',
	},
	selectedCount: {
		fontSize: '14px',
		fontWeight: 500,
	},
	bulkActions: {
		display: 'flex',
		gap: 12,
		flexWrap: 'wrap',
	},
});
